import api from './api';

const url = '/testimonials';

export const getHomeTestimonials = async () => {
  return api({
    url,
    noAuth: true
  });
};